import type { ReactNode } from 'react';
import { cx } from '../../lib/cx';

/**
 * Settings' own layout pieces.
 *
 * The field primitives that used to live here — CONTROL_CLASS, FieldShell,
 * CommittedField, SelectField, InlineStatus — were a verbatim copy of the ones
 * in features/requests/RequestFields.tsx, with a header explaining that they
 * were re-implemented rather than imported because requests/ was outside this
 * milestone's file-ownership boundary. They are in components/Field.tsx now and
 * re-exported below, so this feature's imports did not have to move.
 */
export { CONTROL_CLASS, CommittedField, FieldShell, InlineStatus, SelectField } from '../../components';

export function SectionCard({
  title,
  description,
  children,
  actions,
}: {
  title: string;
  description?: string;
  children: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <section className="rounded-xl border border-line bg-base">
      <header className={cx('flex items-start justify-between gap-3 border-b border-line px-4 py-3')}>
        <div>
          <h2 className="fs-13 font-semibold text-ink">{title}</h2>
          {description !== undefined && <p className="mt-0.5 fs-11.5 text-muted">{description}</p>}
        </div>
        {actions !== undefined && <div className="flex flex-none items-center gap-2">{actions}</div>}
      </header>
      <div className="p-4">{children}</div>
    </section>
  );
}
